import React from 'react';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { Redirect } from 'react-router';
import { baseUrl } from '../common/config.js';
import { axiosCallService } from '../common/apiCallService';
import Paper from 'material-ui/Paper';
import Loading from './Loading.js';
import { saveActivity } from '../common/commonService';
import { Field, reduxForm } from 'redux-form';
import RenderTextField from '../components/CustomFields.js'
import Snackbar from 'material-ui/Snackbar'
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import { domain, partypoker_login_rurl, redirectToMyGame } from '../common/config.js';
import AuthenticateUser from './AuthenticateUser.js'
let PartyPokerIcon = "//" + domain + "/images/replayerIcons/PartyPokerIcon.png";
import queryString from 'query-string';

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loginDone: false,
      formData: {},
      loginRedirect: false,
      errorMsg: '',
      loading: false,
      showErr: false,
      location: '/',
      showLogin: false,
      userRedirect: '',
      fromClient:JSON.parse(localStorage.getItem('fromClient',false))
    }

    // if(props.location.authenticateRole){
    //   localStorage.clear()
    //   console.log(this.state.location);

    //   // alert("Your role is not authenticatd to access this feature ")
    //   // this.setState({errorMsg: "You'r  role is not authenticatd to access this app "})
    //   // this.setState({showErr: true})
    // }

    
    if (!localStorage.getItem('token')) {
      localStorage.clear()
    }

  }

  checkLastHandsDtls = async () => {
    if (JSON.parse(localStorage.getItem('userRole')).includes('PLAYER')) {
      let location = '/',
        playerData = await axiosCallService(`/reportCard/getLast48HrsDtls`, {
          accountName: localStorage.getItem('accountName'), gameType: ['cash', 'tournament', 'Spin'],
          gameSubType: ['Texas Holdem', 'Omaha Hi'],
          ringType: ['6-seater', 'Full Ring', 'Heads-up']
        });
        // if (playerData.data.isMygameLanding) {
        let gameType = "cash", gameSubType = "NLH", ringType = "6-seater", dateRange = "Today", totalHandPlayed = 0
        if (!((['spin', 'plo'].includes((playerData.data.gameType).toLowerCase())) || playerData.data.gameType === 'Omaha Hi')) {
          gameType = playerData.data.gameType
          gameSubType = playerData.data.gameSubType
          ringType = playerData.data.ringType
          dateRange = playerData.data.dateRange
          totalHandPlayed = playerData.data.totalHandPlayed
        }

// } else if (!playerData.data.isMygameLanding) {
//   if (playerData.data.singleReport)
//     location = `/ReportCard/${localStorage.getItem('accountName')}/${playerData.data.gameType}?${queryString.stringify({
//       hitLevel: 'All Level',
//       hitRange: playerData.data.dateRange,
//       hitType: playerData.data.ringType
//     })}`
//   else
//     location = '/SkillLevel?logintype=player'
// }

      location = `/home?${queryString.stringify({ gameType, gameSubType, ringType, dateRange, totalHandPlayed })}`
      this.setState({ userRedirect: location })
      return
    } else {
      this.setState({ userRedirect: `/` })
      return
    }
  }

  async componentDidMount() {
    if (localStorage.getItem('token')) {
      this.setState({ loading: true })
      new Promise((resolve, reject) => {
        AuthenticateUser.validateUser()
          .then(async (data) => {
            await this.checkLastHandsDtls()
          })
          .then((loc) => {
            this.setLocation()
          })
          .then((location) => {
            let userRedirect = this.state.userRedirect
            this.setState({ loading: false })
            this.setState({ loginRedirect: AuthenticateUser.isAuthenticated, location: userRedirect })
          })
          .catch((err) => {
            this.setState({ showLogin: true })
            this.setState({ errorMsg: err.responseJSON.message })
            this.setState({ showErr: true })
          })
      })
    } else {
      this.setState({ showLogin: true })
    }
  }
  setLocation = () => {
    let access = JSON.parse(localStorage.getItem('userRole')),
      location = '/'
    console.log('access', access, access.indexOf('BUSINESS_OWNER'), access.indexOf('SYS_ADMIN'), access.indexOf('COACH'), access.indexOf('PLAYER'));
    if(!this.state.fromClient){
      if (localStorage.getItem('pathName') && localStorage.getItem('sessionTimeOutusername') == localStorage.getItem('username') && localStorage.getItem('pathName') != null && localStorage.getItem('pathName') != '/') {
      location = localStorage.getItem('pathName')
    } else if (access.indexOf('SYS_ADMIN') != -1 || access.indexOf('BUSINESS_OWNER') != -1) {
      location = '/pokerwatch'
    } else if (access.indexOf('COACH') != -1) {
      location = '/pokerwatchteam'
    } else {
      location = this.state.userRedirect
    }
  }
    this.setState({ userRedirect: location })
    return this.state.userRedirect
  }

  handleSubmit = (e) => {
    this.setState({ loading: true })
    e.preventDefault();
    for (const field in this.refs)
      this.state.formData[field] = this.refs[field].value

    new Promise((resolve, reject) => {
      AuthenticateUser.geoInfo()
        .then((geoTrack) => {
          return AuthenticateUser.authenticate(this.state.formData)
        })
        .then(async (data) => {
          let track = {}
          track.hit_page = 'LoginPage';
          track.hit_type = 'PokerWatchLogin';
          track.hit_attribute1 = "success";
          saveActivity(track);
          await this.checkLastHandsDtls()
        })
        .then(async () => {
          await this.setLocation()
        })
        .then(() => {
          let userRedirect = this.state.userRedirect
          this.setState({ loading: false })
          this.setState({ loginRedirect: AuthenticateUser.isAuthenticated, location: userRedirect })
        })
        .catch((err) => {
          let track = {}
          track.hit_page = 'LoginPage';
          track.hit_type = 'PokerWatchLogin';
          track.hit_attribute1 = "fail";
          saveActivity(track);
          this.setState({ errorMsg: "Invalid Username/Password" })
          this.setState({ showErr: true })
          this.setState({ loading: false })
        })
    })
  }

  openPartyPokerWindow = () => {
    window.open(partypoker_login_rurl , "_self", "toolbar=yes,scrollbars=yes,resizable=yes");

  }

  loginToMygame = () => {
    window.open(redirectToMyGame + '?accountId=116186876&partnerToken=f1da42a7-53e3-410f-b9fc-9c6d980819e6&page=course&partner=PartyPoker');
  }

  handleRequestClose = () => {
    this.setState({
      showErr: false,
      errorMsg: ''
    });
  }




  render() {
    return (
      <div>
        {this.state.loading
          ? <Loading />
          : null}
        <AppBar style={{ backgroundColor: '#0f0f10', position: 'fixed', borderBottom: '2px solid #DE460F', height: '50px' }}
          title={<span style={{ color: 'grey', float: 'right', paddingTop: '20px', fontFamily: 'Roboto', fontWeight: 'Semibold', fontSize: '16px' }}><h4 style={{ marginTop: '-5px' }}><b>Log in</b></h4></span>}
          iconStyleRight={{ color: 'white' }} iconStyleLeft={{ color: 'white' }}
          iconElementLeft={<img src={PartyPokerIcon} style={{ width: '30px', float: 'left', marginLeft: '20px' }} />}
        />
        {this.state.showLogin
          ? <form onSubmit={this.handleSubmit}>
            <div className="login" data-e2e="mygamelogin">
              <div className="login-header">
                <h1 style={{ fontFamily: 'Roboto', fontWeight: 'Semibold', fontSize: '36px', color: 'white' }}>Log in</h1>
              </div>
              <div className="login-form">
                <h3 style={{ fontFamily: 'Roboto', fontWeight: 'Semibold', fontSize: '18px', color: 'white' }}>Email(or Username)</h3>
                <input type="text" placeholder="Enter email or username" ref="username" data-e2e="username" required></input><br />
                <h3 style={{ fontFamily: 'Roboto', fontWeight: 'Semibold', fontSize: '18px', color: 'white' }}>Password</h3>
                <input type="password" placeholder="Enter password" ref="password" data-e2e="password" required></input><br />
                <div className="row" style={{ paddingTop: '30px', marginLleft: '0px' }} className="logincss">
                  <div className="col-xs-3 col-sm-3 loginBtn" >
                    <button type="submit" className="btn  btn-lg" data-e2e="loginButton">Log in</button>
                  </div>
                  <div className="col-xs-4 col-sm-4 loginLink" >
                    <span className="btn" style={{ fontFamily: 'Roboto', fontWeight: 'bold', fontSize: '18px', color: 'white' }}>
                      {/*Forget Password?<a href="#" style={{color:'#DE460F',}}> Reset It</a>*/}
                    </span>
                  </div>
                </div>
                <div className="col-xs-3 col-sm-3 loginBtn" >
                  {/* <button type="button" className="btn" onClick={this.openPartyPokerWindow}>log in with party poker</button> */}
                </div>
              </div>
            </div>
          </form>
          : null}

        <span data-e2e="failedLogin">
          <Snackbar open={this.state.showErr} message={this.state.errorMsg} autoHideDuration={8000} bodyStyle={{ color: 'red' }} onRequestClose={this.handleRequestClose} />
          {this.state.loginRedirect && (<Redirect to={this.state.location} />)}
        </span>
      </div>
    )
  }
}

export default Home


/** WEBPACK FOOTER **
 ** ./src/components/home.js
 **/